(function() {
	Vue.component('nominow-editable', {
		model: {
			prop: 'content',
			event: 'change'
		},
		template: '<span contenteditable="true" v-on:keyup="update" v-on:blur="update" ondragenter="return false;" ondragleave="return false;" ondragover="return false;" ondrop="return false;"></span>',
		props: {
			content: {
				type: String,
				required: true,
				default: 'Content'
			},
			css: {
				type: String,
				required: false
			}
		},
		mounted: function() {
			this.$el.innerText = this.content;
			this.$el.className = this.css;
		},
		methods: {
			update: function(event) {
				if (event.keyCode === 13) {
					event.preventDefault();
					event.target.blur();
				}
				this.$emit('change', event.target.innerText);
			}
		}
	});
})();
